import React from 'react';
import { useTheme } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import PropTypes from 'prop-types';

import { SuccessIcon, ErrorIcon, NoticeIcon } from '../index';

import { MuiAlertStyle, StyledIconContainer } from './style';

export const Alert = ({ open, onClose, severity, onClick, children, duration, ...rest }) => {
    const theme = useTheme();
    const mdUp = useMediaQuery(theme.breakpoints.up('sm'));

    const classes = MuiAlertStyle();

    return (
        <Snackbar
            anchorOrigin={
                severity === 'info' && mdUp
                    ? { vertical: 'bottom', horizontal: 'right' }
                    : { vertical: 'top', horizontal: 'center' }
            }
            open={open}
            autoHideDuration={duration !== undefined ? duration : 5000}
            onClose={onClose}
            {...rest}
        >
            <MuiAlert
                elevation={6}
                iconMapping={{
                    error: <ErrorIcon />,
                    success: <SuccessIcon />,
                    info: (
                        <StyledIconContainer>
                            <NoticeIcon width="20" height="20" />
                        </StyledIconContainer>
                    ),
                }}
                onClose={(e) => {
                    e.stopPropagation();
                    onClose();
                }}
                severity={severity}
                className={`${classes.root} ${classes[severity]}`}
                onClick={onClick}
            >
                {children}
            </MuiAlert>
        </Snackbar>
    );
};

Alert.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    severity: PropTypes.string,
    children: PropTypes.any,
    onClick: PropTypes.func,
    duration: PropTypes.number,
    rest: PropTypes.object,
};
